import { render } from "./DashboardView.vue?vue&type=template&id=0d475a9c"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"

import "./DashboardView.vue?vue&type=style&index=0&id=0d475a9c&lang=scss"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__